import React from 'react';

const Sidebar = ({ selectedTab, setSelectedTab }) => {
  const tabs = [
    'Overview',
    'Demographics',
    'DemographicsSQ',
    'Recruitment',
    'RecruitmentMap',
    'Control',
    'CaseManagement',
    'CaseManagementSQ'
  ];

  return (
    <div style={{ width: '200px', padding: '20px', backgroundColor: '#f2f2f2' }}>
      <h3>Dashboard</h3>
      {tabs.map(tab => (
        <div
          key={tab}
          onClick={() => setSelectedTab(tab)}
          style={{
            cursor: 'pointer',
            padding: '10px',
            backgroundColor: selectedTab === tab ? '#ddd' : 'transparent'
          }}
        >
          {tab}
        </div>
      ))}
    </div>
  );
};

export default Sidebar;